import {useAngularService} from "../utils/use-angular-service";

export default () => useAngularService("HttpClientService");
